export default function LightThemeIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path d="M20.8802 13.7665L23 12L20.8802 10.2348L22.1614 7.79024L19.5279 6.96976L19.7764 4.22106L17.0289 4.47082L16.2072 1.83729L13.7652 3.11847L12 1L10.2335 3.11976L7.79024 1.83859L6.96976 4.47212L4.22106 4.22106L4.47082 6.96976L1.83729 7.79024L3.11847 10.2348L1 12L3.11976 13.7665L1.83859 16.2098L4.47212 17.0315L4.22235 19.7789L6.97106 19.5292L7.79153 22.1627L10.2348 20.8815L12 23L13.7665 20.8802L16.2085 22.1614L17.0302 19.5279L19.7776 19.7776L19.5292 17.0302L22.1627 16.2085L20.8802 13.7665Z"></path>
                <circle cx="12" cy="12" r="6"></circle>
            </g>
        </svg>
    ) //these are temporary designs to be replaced by a sergo design
}